import { Card, Send, Button } from "../../ui";
import { buildNotificationBody, getLocalized, getRecipientLabel } from "../utils/notificationHelpers";
import RecipientSelector from "./RecipientSelector";
import TemplateList from "./TemplateList";

export default function SendNotification({
  restaurants,
  templates,
  lang,
  t,
  state,
  setState,
  selectedTemplate,
  onSelectTemplate,
  onSend,
  sending = false,
  sent,
}) {
  const recipientLabel = getRecipientLabel({ restaurants, ...state, lang });
  const previewBody = selectedTemplate ? buildNotificationBody(selectedTemplate, state.note) : { ar: "", en: "" };
  const canSend = Boolean(
    selectedTemplate &&
      (state.recipientMode === "multiple"
        ? state.ownerIds.length > 0
        : state.ownerId && (state.scope !== "branch" || state.branchId))
  );

  return (
    <div className="lud-notif-send-view">
      <div className="lud-notif-support-grid">
        <Card className="lud-notif-compose-box">
          <div className="lud-notif-compose-head">
            <Send size={17} />
            <strong>{t.send.newNotification}</strong>
          </div>

          <div className="lud-notif-compose-body">
            <div className="lud-notif-section-label">{t.send.category}</div>
            <div className="lud-notif-cat-buttons">
              <button
                type="button"
                className={state.composeCategory === "general" ? "is-active" : ""}
                onClick={() => {
                  setState((prev) => ({ ...prev, composeCategory: "general" }));
                  onSelectTemplate("");
                }}
              >
                {t.send.general}
              </button>
              <button
                type="button"
                className={state.composeCategory === "ticket" ? "is-active" : ""}
                onClick={() => {
                  setState((prev) => ({ ...prev, composeCategory: "ticket" }));
                  onSelectTemplate("");
                }}
              >
                {t.send.ticket}
              </button>
            </div>

            <p className="lud-notif-hint-text">{t.send.hint}</p>

            <div className="lud-notif-section-label">{t.send.template}</div>
            <TemplateList
              templates={templates}
              category={state.composeCategory}
              selectedTemplateId={state.selectedTemplateId}
              onSelect={onSelectTemplate}
              t={t}
            />
          </div>
        </Card>

        <div className="lud-notif-right-col">
          <Card className="lud-notif-preview-card">
            <div className="lud-notif-preview-head">
              <strong>{t.send.preview}</strong>
              <span>
                {t.send.recipientPreview} {recipientLabel || t.send.recipientEmpty}
              </span>
            </div>

            <div className="lud-notif-preview-body">
              {selectedTemplate ? (
                <span className={`lud-notif-badge lud-notif-badge--${selectedTemplate.cat}`}>
                  {getLocalized(selectedTemplate, "lbl", "lblEn", lang)}
                </span>
              ) : null}

              <div className="lud-notif-preview-label">{t.send.arabic}</div>
              <div className={`lud-notif-preview-text ${!selectedTemplate ? "is-muted" : ""}`}>
                {selectedTemplate ? previewBody.ar : t.send.selectTemplateAr}
              </div>

              <div className="lud-notif-preview-label" dir="ltr">{t.send.english}</div>
              <div className={`lud-notif-preview-text ${!selectedTemplate ? "is-muted" : ""}`} dir="ltr">
                {selectedTemplate ? previewBody.en : t.send.selectTemplateEn}
              </div>
            </div>
          </Card>

          <RecipientSelector
            restaurants={restaurants}
            lang={lang}
            t={t}
            state={state}
            setState={setState}
            composeCategory={state.composeCategory}
          />

          <div className="lud-notif-form-group">
            <label htmlFor="lud-notif-note">{t.send.note}</label>
            <textarea
              id="lud-notif-note"
              value={state.note}
              placeholder={selectedTemplate?.needsDetail ? selectedTemplate.detailHint || t.send.notePlaceholder : t.send.notePlaceholder}
              onChange={(event) => setState((prev) => ({ ...prev, note: event.target.value }))}
            />
          </div>

          <Button
  variant="primary"
  appearance="filled"
  onClick={onSend}
  disabled={!canSend || sending}
  loading={sending}
  icon={<Send size={16} />}
>
  {t.send.send}
</Button>

          <div className="lud-notif-sec-title">{t.send.sentNotifications}</div>
          <div className="lud-notif-sent-list">
            {sent.length ? (
              sent.map((item) => (
                <Card className="lud-notif-sent-card" key={item.id}>
                  <div className="lud-notif-sent-head">
                    <strong>{getLocalized(item, "title", "titleEn", lang)}</strong>
                    <span className={`lud-notif-badge lud-notif-badge--${item.cat}`}>{getLocalized(item, "lbl", "lblEn", lang)}</span>
                  </div>
                  <small>{item.rest}</small>
                  <p>{getLocalized(item, "body", "bodyEn", lang)}</p>
                </Card>
              ))
            ) : (
              <div className="lud-notif-muted-text">{t.send.noSent}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
